<button mat-icon-button color="secondary" class="flex shrink-0 scale-[0.8]" (click)="copy()" matTooltip="Kopieren"
    i18n-matTooltip>
    <mat-icon [svgIcon]="icon" iconPositionEnd></mat-icon>
</button>